export default __webpack_public_path__ + "static/media/All-Seeing-Eye of Mystical Supremacy.9ea847c6.jpg";